import {Side} from '../enums/side';

export const SELL_SIDE_CLASS = '-sell-side';
export const BUY_SIDE_CLASS = '-buy-side';

export const CLASS_BY_SIDE_MAP = {
    [Side.SELL]: SELL_SIDE_CLASS,
    [Side.BUY]:  BUY_SIDE_CLASS
};
